<template>
  <div class="modal fade" id="questionResponseAnswerModal">
    <div class="modal-dialog modal-lg" role="document">
      <div v-if="responseToEdit != null" class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Fill in the Blank</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="saveQuestionResponseAnswer">
            <div>
              <div class="form-row">
                <div class="col">
                  <label for="answer">Answer</label>
                </div>
                <div class="col-auto">
                  <button
                    type="button"
                    class="btn btn-sm btn-link"
                    v-on:click="clearAnswer"
                  >
                    Clear
                  </button>
                </div>
              </div>
              <textarea
                class="form-control mt-2"
                id="answer"
                rows="6"
                v-bind:placeholder="hint"
                required
                v-model="newAnswer"
              >
              </textarea>
            </div>
            <p class="text-secondary">
              {{ newAnswer.length }} / 4000 characters
            </p>
            <div
              v-if="
                responseToEdit.Application_Template_Response
                  .Template_Response_Blank_Answers
              "
            >
              <div v-if="previousAnswers.length > 0" class="row">
                <div class="col-auto pr-0">
                  <i
                    class="material-icons pointer"
                    id="previousAnswersIcon"
                    data-toggle="collapse"
                    href="#previousAnswers"
                    role="button"
                    aria-expanded="false"
                    v-on:click="$updateToggleIcon('#previousAnswersIcon')"
                    >add</i
                  >
                </div>
                <div class="col">
                  <p
                    class="pointer"
                    data-toggle="collapse"
                    v-on:click="$updateToggleIcon('#previousAnswersIcon')"
                    href="#previousAnswers"
                  >
                    Previous Answers ({{ previousAnswers.length }})
                  </p>
                </div>
              </div>
              <div class="collapse container" id="previousAnswers">
                <div
                  v-for="answer in previousAnswers"
                  :key="answer.Template_Response_Blank_Answer_Id"
                  class="form-row"
                >
                  <div class="col-auto">
                    <button
                      type="button"
                      class="btn btn-sm btn-link"
                      v-on:click="usePreviousAnswer(answer)"
                    >
                      Use
                    </button>
                  </div>
                  <div class="col pt-1">
                    <label
                      class="form-check-label"
                      v-bind:for="
                        'answerRadio' + answer.Template_Response_Blank_Answer_Id
                      "
                    >
                      {{ answer.Answer }}
                    </label>
                  </div>
                  <div class="col-auto">
                    <button
                      type="button"
                      class="btn btn-sm btn-link text-danger"
                      v-on:click="
                        removeAnswer(answer.Template_Response_Blank_Answer_Id)
                      "
                    >
                      Remove
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="text-right">
              <button
                type="submit"
                class="btn btn-primary"
                v-bind:disabled="newAnswer.length == 0"
              >
                Save Answer
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <ConfirmationModal
      Title="Remove Answer"
      Description="Are you sure you want to remove this answer? You will not see it in your previous answers again."
      ConfirmText="Remove"
      Id="removeAnswerModal"
      @confirm="confirmRemoveAnswer"
      @cancel="cancelRemoveAnswer"
    />
  </div>
</template>

<script>
import $ from "jquery";
import ConfirmationModal from "@/modals/ConfirmationModal";

export default {
  name: "QuestionResponseAnswerModal",
  props: {
    ResponseToEdit: Object,
    QuestionCategoryId: String
  },
  components: {
    ConfirmationModal
  },
  data() {
    return {
      newAnswer: "",
      responseToEdit: null,
      originalBlankAnswerId: -1,
      blankNumber: 0,
      originalResponseAnswerId: -1,
      answerToRemoveId: -1,
      previousAnswers: [],
      hint: ""
    };
  },
  watch: {
    ResponseToEdit: function() {
      if (this.ResponseToEdit != null) {
        this.responseToEdit = this.ResponseToEdit.response;
        this.blankNumber = this.ResponseToEdit.blankNumber;
        this.hint = this.findHint();
        if (
          this.ResponseToEdit.response.Grant_Application_Response_Answers
            .length > 0
        ) {
          var blankAnswer = this.ResponseToEdit.response.Grant_Application_Response_Answers.find(
            a =>
              a.Template_Response_Blank_Answer.Blank_Number ==
              this.ResponseToEdit.blankNumber
          );
          this.originalResponseAnswerId = blankAnswer
            ? blankAnswer.Grant_Application_Response_Answer_Id
            : -1;
          this.newAnswer = blankAnswer
            ? blankAnswer.Template_Response_Blank_Answer.Answer
            : "";
          this.originalBlankAnswerId = blankAnswer
            ? blankAnswer.Template_Response_Blank_Answer
                .Template_Response_Blank_Answer_Id
            : -1;
          this.previousAnswers = this.responseToEdit.Application_Template_Response.Template_Response_Blank_Answers.filter(
            a => a.Blank_Number == this.blankNumber
          );
        }
      } else {
        this.clearFields();
      }
    }
  },
  mounted() {
    var view = this;
    $("#questionResponseAnswerModal").on("hidden.bs.modal", function(e) {
      if (e.target.id == "questionResponseAnswerModal") {
        view.$emit("responseAnswerModalClosed");
      } else {
        $("#answer").focus();
      }
    });
    $("#questionResponseAnswerModal").on("shown.bs.modal", function() {
      $("#answer").focus();
    });
  },
  methods: {
    usePreviousAnswer(answer) {
      this.newAnswer = answer.Answer;
      $("#answer").focus();
    },
    clearAnswer() {
      this.newAnswer = "";
      $("#answer").focus();
    },
    removeAnswer(templateResponseBlankAnswerId) {
      this.answerToRemoveId = templateResponseBlankAnswerId;
      $("#removeAnswerModal").modal("show");
    },
    async confirmRemoveAnswer() {
      this.responseToEdit.Application_Template_Response.Template_Response_Blank_Answers = this.responseToEdit.Application_Template_Response.Template_Response_Blank_Answers.filter(
        a => a.Template_Response_Blank_Answer_Id != this.answerToRemoveId
      );
      await this.$removeTemplateResponseBlankAnswer(this.answerToRemoveId);
    },
    cancelRemoveAnswer() {
      this.answerToRemoveId = -1;
    },
    async saveQuestionResponseAnswer() {
      var view = this;
      view.$store.commit("updateLoading", true);
      await this.saveResponseAnswer()
        .then(() => {
          $("#questionResponseAnswerModal").modal("hide");
          view.$store.commit("updateLoading", false);
          view.clearFields();
        })
        .catch(e => {
          console.log(e);
          $("#questionResponseAnswerModal").modal("show");
          view.$store.commit("updateLoading", false);
        });
    },
    async saveResponseAnswer() {
      var responseAnswer = null;
      var trimmedAnswer = this.newAnswer.trim();
      var usedAnswer = this.responseToEdit.Application_Template_Response
        .Template_Response_Blank_Answers
        ? this.responseToEdit.Application_Template_Response.Template_Response_Blank_Answers.find(
            a => a.Answer == trimmedAnswer
          )
        : null;
      if (
        this.responseToEdit.Application_Template_Response
          .Template_Response_Blank_Answers
      ) {
        responseAnswer = await this.createNewResponseBlankAnswer();
      } else if (!usedAnswer) {
        responseAnswer = await this.createNewResponseBlankAnswer();
      } else {
        responseAnswer = usedAnswer;
      }

      if (this.originalResponseAnswerId == -1) {
        await this.createNewResponseAnswer(responseAnswer);
      } else {
        await this.updateResponseAnswer(responseAnswer);
      }
    },
    async createNewResponseBlankAnswer() {
      var view = this;
      var answerToCreate = {
        Application_Template_Response_Id:
          view.responseToEdit.Application_Template_Response
            .Application_Template_Response_Id,
        Blank_Number: view.blankNumber,
        Answer: view.newAnswer
      };
      return await view
        .$createTemplateResponseBlankAnswer(answerToCreate)
        .then(newBlankAnswer => {
          view.$emit("createdNewBlankAnswer", newBlankAnswer);
          return newBlankAnswer;
        });
    },
    async createNewResponseAnswer(responseAnswer) {
      var view = this;
      var responseId = view.responseToEdit.Grant_Application_Response_Id;
      await view
        .$createGrantApplicationResponseAnswer(responseId, responseAnswer)
        .then(newAnswer => {
          view.$emit("createdNewResponseAnswer", newAnswer);
        });
    },
    async updateResponseAnswer(responseAnswer) {
      var view = this;
      await view
        .$updateGrantApplicationResponseAnswer(
          view.originalResponseAnswerId,
          responseAnswer
        )
        .then(updatedAnswer => {
          view.$emit("updatedResponseAnswer", updatedAnswer);
        });
    },
    findHint() {
      var blanks = this.responseToEdit.Application_Template_Response.Response.match(
        /[@]blank-\d+[@](?:hint:[^@]*[@])?/g
      );
      var hints = blanks[this.blankNumber - 1].match(/hint:[^@]+/);
      return hints && hints[0] != ""
        ? hints[0].replace("hint:", "")
        : "New Answer";
    },
    clearFields() {
      this.newAnswer = "";
      this.blankNumber = 0;
      this.originalBlankAnswerId = -1;
      this.originalResponseAnswerId = -1;
      this.previousAnswers = [];
    }
  }
};
</script>
